import { useContentHubStreamStatus } from "../hooks";

/**
 * Compact widget-header badge showing content-hub live stream health.
 * Renders nothing while the stream is connected (or not in use).
 */
export function ContentHubStreamBadge() {
  const status = useContentHubStreamStatus();
  if (status === "connected" || status === "idle") return null;

  return (
    <span
      title="Live stream disconnected — reconnecting. Missed headlines are backfilled automatically on reconnect."
      className="flex items-center gap-1 px-1.5 py-0.5 no-drag text-2xs font-medium text-amber-600 dark:text-amber-400"
    >
      <span className="h-1.5 w-1.5 rounded-full bg-amber-500 animate-pulse" />
      {status === "connecting" ? "Connecting" : "Reconnecting"}
    </span>
  );
}
